import type { SVGProps } from 'react';
const SvgPlusOne = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#plus_one_svg__a)">
      <path
        fill="currentColor"
        d="M10 8H8v4H4v2h4v4h2v-4h4v-2h-4V8Zm4.5-1.92V7.9l2.5-.5V18h2V5l-4.5 1.08Z"
      />
    </g>
    <defs>
      <clipPath id="plus_one_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPlusOne;
